// removed by extract-text-webpack-plugin
module.exports = {"container":"container_1mRGw","viewWrapper":"viewWrapper_3CWBr","App-logo":"App-logo_1gUo2","App-logo-spin":"App-logo-spin_3FLW6","App-header":"App-header_DPvJ_","App-intro":"App-intro_39NUC"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/container/App.css
 ** module id = 938
 ** module chunks = 0
 **/